import {
  ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, Renderer2,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'a[mcrai-button], button[mcrai-button], label[mcrai-button]',
  template: `<ng-content></ng-content>
`,
  styles: [`.mcrai-button{display:inline-flex;border:0;outline:0;text-decoration:none;font-size:14px;min-width:54px;height:45px;align-items:center;padding:0 20px;margin:0 2px;cursor:pointer;box-sizing:border-box;justify-content:center;white-space:nowrap;transition:background-color .2s;transition-timing-function:cubic-bezier(.25,.8,.25,1)}.mcrai-button:first-letter{text-transform:uppercase}.mcrai-button--disabled{pointer-events:none;cursor:none}`],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.mcrai-button]': 'true'
  }
})
export class ButtonComponent implements OnInit {
  @Input('mcrai-button') set mcraiButton(value: string) {
    this.color = value;
  }

  @Input('color') set color(value: string) {
    this._removeAllColorClasses();

    if (value) {
      this._renderer.addClass(this._elRef.nativeElement, `mcrai-button--${value}`);
    }
  }

  @Input() set disabled(value: boolean) {
    if (value) {
      this._renderer.addClass(this._elRef.nativeElement, `mcrai-button--disabled`);
    } else {
      this._renderer.removeClass(this._elRef.nativeElement, `mcrai-button--disabled`);
    }
  }

  constructor(
    private _renderer: Renderer2,
    private _elRef: ElementRef,
  ) { }

  ngOnInit() { }

  private _removeAllColorClasses() {
    const colors = ['neutral', 'positive', 'negative'];

    colors.forEach(color => {
      this._renderer.removeClass(this._elRef.nativeElement, `mcrai-button--${color}`);
    });
  }
}
